import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CommonService from "../../services/common.service";
import PlayerCardModal from "../Player/PlayerCardModal";
import moment from "moment";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";

const Timeline = () => {
  useAutoAddQueryString();
  const [timelineData, setTimelineData] = useState([]);
  const [playerList, setPlayerList] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    setTimelineData([]);
    // dispatch(getStat({ rd, page: currentPage, perPage }));
    CommonService.getTimelineData("fantasy_points").then((res) => {
      if (res.success) {
        setTimelineData(res.data);
        setPlayerList(res.players);
      }
    });
  }, []);
  const [show, setShow] = useState(false);
  const [playerCardData, setPlayerCardData] = useState({});
  const [playerCardModalData, setPlayerCardModalData] = useState({});
  const [playerTeamName, setPlayerTeamName] = useState();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const playerCardHandle = (item) => {
    setShow(true);
    setPlayerCardData(item);
    CommonService.getPlayerCardDetail(item.id).then((res) => {
      if (res.status === 200) {
        setPlayerCardModalData(res.data);
        setPlayerTeamName(res.teamName);
      }
    });
  };

  const handleShowType = (type) => {
    setTimelineData([]);
    CommonService.getTimelineData(type).then((res) => {
      if (res.success) {
        setTimelineData(res.data);
      }
    });
  };

  // const handleLikeDislike = (id) => {
  //   setTimelineData((prevItems) =>
  //     prevItems.map((item) =>
  //       item.id === id ? { ...item, liked: !item.liked } : item
  //     )
  //   );
  //   // save Likes
  //   const data = {};
  //   data.scorecardId = id;
  //   CommonService.saveLikeDislike(data);
  // };

  const handleLikeDislike = (item) => {
    // Replace this with your actual logic to update the like/dislike status on the server
    const updatedData = timelineData.map((dataItem) => {
      if (dataItem.id === item) {
        if (dataItem.liked) {
          dataItem.total_like -= 1; // Decrease the like count
        } else {
          dataItem.total_like += 1; // Increase the like count
        }
        dataItem.liked = !dataItem.liked; // Toggle the liked status
      }
      return dataItem;
    });

    setTimelineData(updatedData);

    const data = {};
    data.scorecardId = item;
    CommonService.saveLikeDislike(data);
  };

  useEffect(() => {
    const filtered = timelineData.filter((item) => {
      return (
        selectedPlayerId === null ||
        selectedPlayerId === "" ||
        item.player_id == selectedPlayerId
      );
    });
    setFilteredData(filtered);
  }, [timelineData, selectedPlayerId]);

  const handlePlayerSelect = (playerId) => {
    setSelectedPlayerId(playerId);
  };
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Timeline</h2>
            </div>
            <div className="filter_content">
              <div className="choosen_selct">
                <select
                  className="form-control"
                  disabled=""
                  onChange={(e) => handlePlayerSelect(e.target.value)}
                  value={selectedPlayerId || ""}
                >
                  <option value={""}>All Players</option>
                  {playerList &&
                    playerList.map((item, key) => (
                      <option key={key} value={item?.player_id}>
                        {item?.full_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Overall"
                  type="button"
                  role="tab"
                  aria-controls="Overall"
                  aria-selected="true"
                  onClick={() => handleShowType("fantasy_points")}
                >
                  Fantasy
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Bating-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Bating"
                  type="button"
                  role="tab"
                  aria-controls="Bating"
                  aria-selected="true"
                  onClick={() => handleShowType("bat")}
                >
                  {" "}
                  Batting
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Bowling-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Bowling"
                  type="button"
                  role="tab"
                  aria-controls="Bowling"
                  aria-selected="false"
                  onClick={() => handleShowType("bowl")}
                >
                  {" "}
                  Bowling
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Fielding-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Fielding"
                  type="button"
                  role="tab"
                  aria-controls="MonFieldingth"
                  aria-selected="false"
                  onClick={() => handleShowType("ar")}
                >
                  {" "}
                  Fielding
                </button>
              </li> */}
            </ul>
            <div className="tab-content" id="timeline">
              <div
                className="tab-pane fade show active"
                id="Overall"
                role="tabpanel"
                aria-labelledby="Overall-tab"
              >
                <div className="roadmap mCustomScrollbar">
                  <ul className="roadmaplist">
                    {filteredData &&
                      filteredData.map((item, key) => (
                        <li key={key}>
                          <span>
                            {moment(item?.created_at).format("D.MM.YYYY")}
                          </span>
                          <div className="roadmapbox">
                            <div className="timelinebox">
                              <div className="timelinebox-content">
                                <div className="playerprofile">
                                  <Link
                                    onClick={() =>
                                      playerCardHandle(item?.player)
                                    }
                                  >
                                    <figure>
                                      {item?.player.is_avatar === 1 ? (
                                        <img
                                          src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item?.player?.image}`}
                                          alt="img"
                                        />
                                      ) : (
                                        <img
                                          src={`${process.env.REACT_APP_UPLOAD_URL}player/${item?.player?.image}`}
                                          alt="img"
                                        />
                                      )}
                                    </figure>
                                    <h4>{item?.player.full_name}</h4>
                                  </Link>
                                  <div className="aboutplayer">
                                    Congrats {item?.player.full_name} on
                                    collecting {item?.fantasy_points} points for
                                    your performance in the{" "}
                                    <Link
                                      to={`/match-scorecard/${item.fixture_id}`}
                                      className=""
                                      style={{ display: "contents" }}
                                    >
                                      {item?.team_name}
                                    </Link>
                                    {" match."}
                                    <ul>
                                      <li>
                                        <Link style={{ display: "contents" }}>
                                          <i className="fas fa-thumbs-up"></i>
                                          {item?.total_like}
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="playerscore">
                                  <strong>{item?.fantasy_points}</strong>Points
                                </div>
                              </div>
                              <div
                                id="Comment1"
                                className="collapse commentlist"
                              >
                                <ul>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                              <div className="otheroption">
                                <ul>
                                  <li>
                                    <Link
                                      onClick={() => handleLikeDislike(item.id)}
                                    >
                                      <i
                                        className={`fas ${
                                          item.liked
                                            ? "fa-thumbs-down"
                                            : "fa-thumbs-up"
                                        }`}
                                      ></i>{" "}
                                      {item.liked ? "Liked" : "Like"}
                                    </Link>
                                  </li>

                                  {/* <li>
                                    <a href="">
                                      <i className="fas fa-share"></i>Share
                                    </a>
                                  </li> */}
                                </ul>
                              </div>
                              {/* <div className="commentoption">
                                <figure>
                                  <img src="images/no-img.png" alt="img" />
                                </figure>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="What's on your mind?"
                                />
                              </div> */}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="Bating"
                role="tabpanel"
                aria-labelledby="Bating-tab"
              >
                <div className="roadmap mCustomScrollbar">
                  <ul className="roadmaplist">
                    {filteredData &&
                      filteredData.map((item, key) => (
                        <li key={key}>
                          <span>
                            {moment(item?.created_at).format("D.MM.YYYY")}
                          </span>
                          <div className="roadmapbox">
                            <div className="timelinebox">
                              <div className="timelinebox-content">
                                <div className="playerprofile">
                                  <Link
                                    onClick={() =>
                                      playerCardHandle(item?.player)
                                    }
                                  >
                                    <figure>
                                      {item?.player.is_avatar === 1 ? (
                                        <img
                                          src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item?.player?.image}`}
                                          alt="img"
                                        />
                                      ) : (
                                        <img
                                          src={`${process.env.REACT_APP_UPLOAD_URL}player/${item?.player?.image}`}
                                          alt="img"
                                        />
                                      )}
                                    </figure>
                                    <h4>{item?.player.full_name}</h4>
                                  </Link>
                                  <div className="aboutplayer">
                                    Congrats {item?.player.full_name} on scoring{" "}
                                    {item?.rs} runs in the{" "}
                                    <Link
                                      to={`/match-scorecard/${item.fixture_id}`}
                                      className=""
                                      style={{ display: "contents" }}
                                    >
                                      {item?.team_name}
                                    </Link>{" "}
                                    match.
                                    <ul>
                                      <li>
                                        <Link>
                                          <i className="fas fa-thumbs-up"></i>{" "}
                                          {item?.total_like}
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="playerscore">
                                  <strong>{item?.rs}</strong>Runs
                                </div>
                              </div>
                              <div
                                id="Comment1"
                                className="collapse commentlist"
                              >
                                <ul>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                              <div className="otheroption">
                                <ul>
                                  <li>
                                    <Link
                                      onClick={() => handleLikeDislike(item.id)}
                                    >
                                      <i className="fas fa-thumbs-up"></i>Like
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              {/* <div className="commentoption">
                                <figure>
                                  <img src="images/no-img.png" alt="img" />
                                </figure>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="What's on your mind?"
                                />
                              </div> */}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="Bowling"
                role="tabpanel"
                aria-labelledby="Bowling-tab"
              >
                <div className="roadmap mCustomScrollbar">
                  <ul className="roadmaplist">
                    {filteredData &&
                      filteredData.map((item, key) => (
                        <li key={key}>
                          <span>
                            {moment(item?.created_at).format("D.MM.YYYY")}
                          </span>
                          <div className="roadmapbox">
                            <div className="timelinebox">
                              <div className="timelinebox-content">
                                <div className="playerprofile">
                                  <Link
                                    onClick={() =>
                                      playerCardHandle(item?.player)
                                    }
                                  >
                                    <figure>
                                      {item?.player.is_avatar === 1 ? (
                                        <img
                                          src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item?.player?.image}`}
                                          alt="img"
                                        />
                                      ) : (
                                        <img
                                          src={`${process.env.REACT_APP_UPLOAD_URL}player/${item?.player?.image}`}
                                          alt="img"
                                        />
                                      )}
                                    </figure>
                                    <h4>{item?.player.full_name}</h4>
                                  </Link>
                                  <div className="aboutplayer">
                                    Congrats {item?.player.full_name} on picking{" "}
                                    {item?.wks} wickets in the{" "}
                                    <Link
                                      to={`/match-scorecard/${item.fixture_id}`}
                                      style={{ display: "contents" }}
                                    >
                                      {item?.team_name}
                                    </Link>{" "}
                                    match.
                                    <ul>
                                      <li>
                                        <Link>
                                          <i className="fas fa-thumbs-up"></i>{" "}
                                          {item?.total_like}
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="playerscore">
                                  <strong>{item?.wks}</strong>
                                  Wickets
                                </div>
                              </div>
                              <div
                                id="Comment1"
                                className="collapse commentlist"
                              >
                                <ul>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                              <div className="otheroption">
                                <ul>
                                  <li>
                                    <Link
                                      onClick={() => handleLikeDislike(item.id)}
                                    >
                                      <i className="fas fa-thumbs-up"></i>Like
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              {/* <div className="commentoption">
                                <figure>
                                  <img src="images/no-img.png" alt="img" />
                                </figure>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="What's on your mind?"
                                />
                              </div> */}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="Fielding"
                role="tabpanel"
                aria-labelledby="Fielding-tab"
              >
                <div className="roadmap mCustomScrollbar">
                  <ul className="roadmaplist">
                    {timelineData &&
                      timelineData.map((item, key) => (
                        <li key={key}>
                          <span>
                            {moment(item?.created_at).format("D.MM.YYYY")}
                          </span>
                          <div className="roadmapbox">
                            <div className="timelinebox">
                              <div className="timelinebox-content">
                                <div className="playerprofile">
                                  <Link
                                    onClick={() =>
                                      playerCardHandle(item?.player)
                                    }
                                  >
                                    <figure>
                                      {item?.player.is_avatar === 1 ? (
                                        <img
                                          src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item?.player?.image}`}
                                          alt="img"
                                        />
                                      ) : (
                                        <img
                                          src={`${process.env.REACT_APP_UPLOAD_URL}player/${item?.player?.image}`}
                                          alt="img"
                                        />
                                      )}
                                    </figure>
                                    <h4>{item?.player.full_name}</h4>
                                  </Link>
                                  <div className="aboutplayer">
                                    <Link
                                      to={`/match-scorecard/${item.fixture_id}`}
                                      className=""
                                    >
                                      {item?.team_name}
                                    </Link>
                                    <ul>
                                      <li>
                                        <Link>
                                          <i className="fas fa-thumbs-up"></i>{" "}
                                          {item?.total_like}
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="playerscore">
                                  <strong>{item?.fantasy_points}</strong>Points
                                </div>
                              </div>
                              <div
                                id="Comment1"
                                className="collapse commentlist"
                              >
                                <ul>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                  <li>
                                    <figure>
                                      <img src="images/no-img.png" alt="img" />
                                    </figure>
                                    <h4>K Harris</h4>
                                    <p>
                                      Lorem Ipsum is simply dummy text of the
                                      printing and typesetting industry.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                              <div className="otheroption">
                                <ul>
                                  <li>
                                    <Link
                                      onClick={() => handleLikeDislike(item.id)}
                                    >
                                      <i className="fas fa-thumbs-up"></i>Like
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              {/* <div className="commentoption">
                                <figure>
                                  <img src="images/no-img.png" alt="img" />
                                </figure>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="What's on your mind?"
                                />
                              </div> */}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PlayerCardModal
        show={show}
        handleClose={handleClose}
        handleShow={handleShow}
        playerCardData={playerCardData}
        playerCardModalData={playerCardModalData}
        playerTeamName={playerTeamName}
      />
    </>
  );
};

export default Timeline;
